module.exports = __webpack_public_path__ + "img/image_service_5.cd917150.png";